// extracted by mini-css-extract-plugin
export default {"box":"pc_box__t6ZI4","title":"pc_title__DC4DA","title2":"pc_title2__YyxUo"};